import React , {useEffect} from 'react';
import { BrowserRouter , Routes, Route } from "react-router-dom";
import ProtectedRoute from "./components/Auth/ProtectedRoute";
import PublicRoute from "./components/Auth/PublicRoute";
import Home from "./pages/Home";
import Registration from "./pages/User/Registration";
import Login from "./pages/User/Login";
import ForgotPassword from "./pages/User/ForgotPassword";
import ResetPassword from "./pages/User/ResetPassword";
import Dashboard from "./pages/Dashboard/Dashboard";
import MyItems from "./pages/Dashboard/MyItems";
import Setting from "./pages/Dashboard/Setting";
import Notification from "./pages/Dashboard/Notification";
import MyOrder from "./pages/Dashboard/MyOrder";
import OrderDetails from "./pages/Dashboard/OrderDetails";

import Cart from "./pages/Order/Cart";
import Checkout from "./pages/Order/Checkout";
import OrderConfirmation from "./pages/Order/OrderConfirmation";
import PaymentConfirmation from "./pages/Order/PaymentConfirmation";
import PaymentCancelled from "./pages/Order/PaymentCancelled";
import Listing from "./pages/Listing";
import Details from "./pages/Details";
import NotFound from "./pages/NotFound";
import logo from './logo.svg';
import './App.css';


function App() {

  // useEffect(() => {
  //   const handleRightClick = (e: MouseEvent) => {
  //     e.preventDefault();
  //   };

  //   document.addEventListener("contextmenu", handleRightClick);

  //   return () => {
  //     document.removeEventListener("contextmenu", handleRightClick);
  //   };
  // }, []);

  // useEffect(() => {
  //   const blocker = document.createElement("div");
  //   blocker.id = "devtools-blocker";
  //   blocker.innerText = "DevTools detected! Closing for security...";
  //   document.body.appendChild(blocker);

  //   const checkDevTools = setInterval(() => {
  //     const threshold = 160;
  //     const isOpen = 
  //       window.outerWidth - window.innerWidth > threshold ||
  //       window.outerHeight - window.innerHeight > threshold;

  //     if (isOpen) {
  //       blocker.style.display = "block";

  //       setTimeout(() => {
  //         window.location.reload(); // Reload after showing warning
  //       }, 10000); // 10 seconds
  //     } else {
  //       blocker.style.display = "none";
  //     }
  //   }, 1000);

  //   return () => {
  //     clearInterval(checkDevTools);
  //     blocker.remove();
  //   };
  // }, []);

  return (
    <BrowserRouter>
      {/* <BrowserRouter basename="/e-learning/front"> */}
        <Routes>
          {/* Public routes */}
          <Route path="/" element={<Home />} />
          
          <Route element={<PublicRoute />}>
            <Route path="/registration" element={<Registration />} />
            <Route path="/login" element={<Login />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password/:token" element={<ResetPassword />} />
          </Route>

          {/* Protected routes */}
          <Route element={<ProtectedRoute />}>
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/my-items" element={<MyItems />} />
            <Route path="/my-orders" element={<MyOrder />} />
            <Route path="/order-details/:id" element={<OrderDetails />} />
            <Route path="/notifications" element={<Notification />} />
            <Route path="/settings" element={<Setting />} />
            <Route path="/payment-confirmation" element={<PaymentConfirmation />} />
            <Route path="/payment-cancelled" element={<PaymentCancelled />} />
            <Route path="/cart" element={<Cart />} />
            <Route path="/checkout" element={<Checkout />} />
          </Route>
          
          {/* Public routes */}
          <Route path="/:slug" element={<Listing />} />
          <Route path="/:slug/:content" element={<Details />} />
          <Route path="*" element={<NotFound />} />

        </Routes>
    </BrowserRouter>
  
  );
}

export default App;
